import React from "react";

const generateColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ("00" + value.toString(16)).substr(-2);
    }
    return color;
  };

const generateInitials = (name) => {
  return name
    ?.split(" ")
    ?.map((word) => word.charAt(0).toUpperCase())
    ?.join("");
};

const NameAvatar = ({ name="" }) => {
  const backgroundColor = generateColor(name);
  const initials = generateInitials(name);

  return (
    <div
    className="user-img"
      style={{
       
        backgroundColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        fontWeight: "bold",
        fontSize: "32px",
      }}
    >
      {initials}
    </div>
  );
};

export default NameAvatar;
